export const ApiMethod = {
  GET: "get",
  POST: "post",
} as const;

export type ApiMethod = (typeof ApiMethod)[keyof typeof ApiMethod];
